import React from 'react';

export function DevelopedWithBolt() {
  return (
    <a
      href="https://bolt.new"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 px-3 py-1.5 bg-zinc-900 text-zinc-400 text-xs rounded-md border border-zinc-800 hover:border-zinc-700 hover:text-zinc-300 transition-colors duration-200"
    >
      Developed with <span className="font-semibold text-zinc-200">Bolt.new</span>
    </a>
  );
}

export function DevelopedWithBoltSimple() {
  return (
    <a
      href="https://bolt.new"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 px-3 py-1.5 bg-zinc-900 text-zinc-400 text-xs rounded-md border border-zinc-800 hover:border-zinc-700 hover:text-zinc-300 transition-colors duration-200"
    >
      Developed with <span className="font-semibold text-zinc-200">Bolt.new</span>
    </a>
  );
}